import gql from "graphql-tag";

import type {GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {
    hideProgramEverywhere as Data,
    hideProgramEverywhereVariables as Variables,
} from "./__graphql-types__/hideProgramEverywhere.ts";

export const HIDE_PROGRAM_EVERYWHERE: GqlOperation<Data, Variables> = gqlOp(gql`
    mutation hideProgramEverywhere($programID: ID!, $hide: Boolean!) {
        hideProgramEverywhere(programID: $programID, hide: $hide) {
            error {
                code
                debugMessage
            }
        }
    }
`);

export async function hideProgramEverywhere(
    gqlFetch: GqlFetchFn,
    programID: string,
    hide: boolean,
): Promise<void> {
    try {
        const data = await gqlFetch(HIDE_PROGRAM_EVERYWHERE, {
            variables: {programID, hide},
        });

        if (data?.hideProgramEverywhere?.error) {
            throw new KAError(
                "hideProgramEverywhere returned an error",
                Errors.Internal,
                {
                    cause: JSON.stringify(data?.hideProgramEverywhere?.error),
                },
            );
        }
    } catch (e: any) {
        throw new KAError(
            "Error hiding a program everywhere",
            Errors.Internal,
            {
                cause: e,
            },
        );
    }
}
